"use strict";
/*
Copyright (C) 2009 - 2020 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultChildrenVisibilityType = void 0;
var DefaultChildrenVisibilityType;
(function (DefaultChildrenVisibilityType) {
    /**
     * Indicates an account entity is not visible to children accounts.
     * For example, the account address or saved payment method is only visible to its own account but not sub-accounts.
     */
    DefaultChildrenVisibilityType["NO"] = "NO";
    /**
     * Indicates an account entity is visible to children accounts.
     * For example, the account address or saved payment method is both visible to its own account and sub-accounts.
     */
    DefaultChildrenVisibilityType["YES"] = "YES";
})(DefaultChildrenVisibilityType = exports.DefaultChildrenVisibilityType || (exports.DefaultChildrenVisibilityType = {}));
//# sourceMappingURL=common.js.map